import type * as React from 'react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'
import ComposerActionCreators from '../../action-creators/ComposerActionCreators'
import { FieldWrapper, Input, Label } from '../channel-fields/styles'
import CharacterCount from '../CharacterCount'

const ThreadsTopicCharacterCount = styled(CharacterCount)`
  display: inline-block;
  border-radius: 4px;
  padding: 3px 3px;
  line-height: 12px;
  position: absolute;
  right: 6px;
`

interface ThreadsTopicFieldProps {
  draft: Draft
}

const ThreadsTopicField: React.FC<ThreadsTopicFieldProps> = ({ draft }) => {
  const [inputValue, setInputValue] = useState('')
  const topicLength = inputValue.length

  useEffect(() => {
    const topic = draft?.channelData?.threads?.topic ?? ''
    setInputValue(topic)
  }, [draft])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value
    setInputValue(value)

    ComposerActionCreators.updateDraftThreadsData({
      ...draft.channelData?.threads,
      topic: value,
    })
  }

  return (
    <FieldWrapper>
      <Label htmlFor="threads-topic">Topic</Label>
      <Input
        id="threads-topic"
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Type the topic"
      />
      {topicLength > 40 && (
        <ThreadsTopicCharacterCount count={topicLength} maxCount={50} />
      )}
    </FieldWrapper>
  )
}

export default ThreadsTopicField
